import axios from 'axios'
import router from '@/router' // 引入路由实例，用于跳转
import { MsgBoxBack } from '@/util/msgutil/msgBox'// 引入自定义弹框工具

// 后端基础地址配置
// export const baseURL = 'http://localhost:8088/job8_1'
export const baseURL = 'https://scslzs.top/job8_1'

// 创建 Axios 实例
const service = axios.create({
    baseURL: baseURL, //http://你的后端接口域名:端口 例如：http://localhost:8080
    timeout: 10000 // 请求超时时间
    // headers: {
    //     'Content-Type': 'application/json;charset=utf-8'
    // } 强制把前端请求都封装成 application/json 后端只能接收这个格式，关掉传递不同请求类型
})

// 请求拦截器：可添加 token 等公共参数
service.interceptors.request.use(
    (config) => {
        // 拿到token 拼接后端请求头
        const token = sessionStorage.getItem('token')
        if (token) config.headers.Authorization = `Bearer ${token}`
        //  添加角色信息
        const currentRoleStr  = sessionStorage.getItem('currentRole');
        if (currentRoleStr ) {
            // 只传递roleId（后端要什么字段传什么，比如roleId/roleName）
            config.headers['X-RoleId'] = currentRoleStr || '';
        }

        return config //Promise.resolve(xxx) 或直接返回数据 进入成功回调流程
    },
    (error) => {
        return Promise.reject(error)
    }
)

// 响应拦截器：处理后端返回的错误（包括token过期）
service.interceptors.response.use(
    (response) => {
        const res = response.data
        // 假设后端成功状态码为200，其他为错误
        if (res.code !== 200) {
            // 处理token过期（假设后端用401表示未授权/token过期）
            if (res.code === 401) {
                MsgBoxBack.warning('登录已过期，请重新登录', () => {
                    sessionStorage.removeItem('token')
                    router.push('/login') // 跳转到登录页
                });
            }
            res.msg = res.msg ? res.msg : "请求失败";
            // return Promise.reject(new Error(res.msg || '请求失败'))//返回Promise.reject 进入失败流程
            return res;
        }
        return res
    },
    (error) => {
        // 处理HTTP状态码错误（如401、500等）
        if (error.response && error.response.status === 401) {
            MsgBoxBack.warning('登录已过期，请重新登录', () => {
                sessionStorage.removeItem('token')
                router.push('/login') // 跳转到登录页
            });
        }
        const errMsg = error.message || '服务器异常，请稍后重试'
        return Promise.reject(errMsg)
    }
)

export default service